import { createSelector } from 'reselect';

const projectStore = state => state.projects;
const selectProjectId = (state, projectId) => projectId;
const projectSelector = () =>
  createSelector([projectStore, selectProjectId], (projectStore, projectId) => ({
    project: projectStore[projectId]
  }));
export { projectSelector };
